import { render, staticRenderFns } from "./Hourglass.vue?vue&type=template&id=65cc346a&scoped=true&"
import script from "./Hourglass.vue?vue&type=script&lang=js&"
export * from "./Hourglass.vue?vue&type=script&lang=js&"
import style0 from "./Hourglass.vue?vue&type=style&index=0&id=65cc346a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cc346a",
  null
  
)

export default component.exports